import UMSG_TYPE from 'constants/umsg/type.const';
import isEnumVal from 'utils/predicates/enum/isEnumVal.util';
import isFn from 'utils/predicates/function/isFn.util';

const fromAnyToUmsgType = (value) => {
  if (isEnumVal(UMSG_TYPE, value)) return value;
  if (isFn(value)) return UMSG_TYPE.fn;
  if (isFn(value?.fn)) return UMSG_TYPE.fn;
  if (null === value) return UMSG_TYPE.none;
  return UMSG_TYPE.any;
};

export default fromAnyToUmsgType;
